<template>
<div class="base-list-content">
  <slot name="tag"></slot>
  <div class="list-item">
    <slot></slot>
  </div>
  <slot name="text-tag"></slot>
</div>

</template>
<script>
export default {
  name: 'base-list-content',
  data () {
    return {}
  },
  methods: {}
}
</script>
<style lang="stylus" scoped>
.base-list-content
  .list-item //依照標籤內區塊內容自動分
    display: flex;
    align-items: center;
    word-break: break-all
    text-align center
    padding: 10px 0
    *
      flex:1
    .text-ellipsis
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;

.base-list-content+.base-list-content
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid rgba(0,0,0,0.12);
@media only screen and (min-width: 1025px){
 .base-list-content .list-item>*{
    flex: 1
    }
 .base-list-content .list-item>*:first-child{
    flex: 2
    }
  }

</style>
